import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function ReturnReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Reference No",
      accessorKey: "Reference No",
    },
    {
      header: "Date",
      accessorKey: "Date",
    },

    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "Vat",
      accessorKey: "Vat",
    },
    {
      header: "Total amount",
      accessorKey: "Total amount",
    },
    {
      header: "Description",
      accessorKey: "Description",
    },
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
    },
  ]);

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Return Report"}
        buttonDataa={buttonDataa}
      />
    </main>
  );
}

export default ReturnReport;
